import SidebarMobile from "./SidebarMobile";
import routes from "../../utils/Routes/Sidebar";
import {NavLink, useNavigate} from 'react-router-dom'
import {useLocation} from "react-router-dom";
import SidebarSubMenu from "./SidebarSubMenu";
import SideBarIcon from "../Icon/SideBarIcon";
import {useDrawer} from "../../redux/Reducers/DrawerReducer";
import {useEffect} from "react";
import {useSelector} from "react-redux";

function SidebarBody({className, ...props}) {

    return (
        <>
            <SidebarMobile>
                {props.children}
            </SidebarMobile>
        </>

    )
}

export default function Sidebar({className, ...props}) {
    const languagesSlice = useSelector(state => state.LanguageSlice);

    const naivation = useNavigate();
    const {actions} = useDrawer();
    useEffect(() => {
        if (window.location.href.includes("practice/")) {
            actions.closeDrawer()
        }
    }, []);

    return (
        <SidebarBody>


            <ul className="mt-6">
                {routes.map((route,index) => {
                    return route?.Component ? (<route.Component key={index} />) : route.routes ? (
                        <SidebarSubMenu route={route} key={route.name}/>
                    ) : (
                        <li className="relative px-6 py-3" key={index}>
                            <div
                                onClick={() => {
                                    naivation(route.path)
                                    actions.closeDrawer()
                                }}
                                key={index}
                                className="inline-flex cursor-pointer text-gray-800 hover:text-gray-500 dark:text-gray-100 dark:hover:text-gray-300 items-center w-full text-base font-semibold  duration-150 "
                            >


                                {
                                    route.icon ? <SideBarIcon name={route.icon}/> : null
                                }
                                <span className="ml-4 ">{
                                    route.translatedNames[languagesSlice.selectedLanguageObject.id] || route.name

                                }
                                </span>
                            </div>
                        </li>
                    )
                })}
            </ul>

        </SidebarBody>

    )
}
